import {CourseLanguage} from '../../../../../../../oj-app-common/shop/types/course-language';
import {AnyCurrency} from '../../../../../../../oj-app-common/shop/types/any-currency';

export class EshopPreferencesModel {
  taughtLanguage: CourseLanguage;
  studentLanguage: CourseLanguage;
  currency: AnyCurrency;
}
